<template>
  <div class="button-menu-wrapper" @click="onClick" :class="{'button-menu-selected':selected}">
    <span class="new-item" v-if="isNew">new</span>
    <div class="button-menu stop-event">
      <span class="button-menu-icon base-sprite" :class="iconClass" v-if="iconClass"></span>
      <span class='button-menu-label'  v-if="label">{{label}}</span>
    </div>
  </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////

//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'buttontextstyle',
  components: {
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  data () {
    return {
      selected:false
    }
  },
  props: {
    iconClass:{
      type:String,
      default:''
    },
    label:{
      type:String,
      default:''
    },
    isNew:{
      type:Boolean,
      default:false
    },
    value:null
  },
  computed: {},
  methods: {
    onClick(){
      this.selected =!this.selected
      this.$emit('click', {selected:this.selected, value:this.value})
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/buttons/ButtonTextStyle.vue